import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
                fill: "#1A2333"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.72917 13.0417C4.50694 12.625 4.32986 12.184 4.19792 11.7188C4.06597 11.2535 4 10.7639 4 10.25C4 8.56944 4.59028 7.13889 5.77083 5.95833C6.95139 4.77778 8.40278 4.20833 10.125 4.25L8.9375 3.0625L10 2L13 5L10 8L8.9375 6.9375L10.125 5.75C8.81944 5.72222 7.72222 6.15278 6.83333 7.04167C5.94444 7.93056 5.5 9 5.5 10.25C5.5 10.5556 5.52778 10.8472 5.58333 11.125C5.63889 11.4028 5.72222 11.6736 5.83333 11.9375L4.72917 13.0417ZM10 18.5L7 15.5L10 12.5L11.0625 13.5625L9.875 14.75C11.1806 14.7778 12.2778 14.3472 13.1667 13.4583C14.0556 12.5694 14.5 11.5 14.5 10.25C14.5 9.94444 14.4722 9.65278 14.4167 9.375C14.3611 9.09722 14.2778 8.82639 14.1667 8.5625L15.2708 7.45833C15.4931 7.875 15.6701 8.31597 15.8021 8.78125C15.934 9.24653 16 9.73611 16 10.25C16 11.9167 15.4097 13.3438 14.2292 14.5312C13.0486 15.7188 11.5972 16.2917 9.875 16.25L11.0625 17.4375L10 18.5Z",
                fill: "#EEF0F4"
            })
        ]
    }));
};
export default Icon;
